import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Import i18n (must be before App)
import '@nohara-dxdev/react-core';

import { App } from './app';
import { ThemeRegistry } from './theme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeRegistry>
      <App />
    </ThemeRegistry>
  </StrictMode>
);
